<style scoped lang="scss">
  .note{
    display: flex;
    align-items: flex-start;
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
        font-size: 16px;
      }
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
    .wrap-intel{
      margin-bottom: 0!important;
    }
    .con{
      display: none!important;
    }
    .cons{
      display: block!important;
    }
    .cons .device{
      display: block!important;
    }
    .cons .device li{
      width: 100% !important;
      display: block!important;
      height: 385px;
    }
    .wrap-intel .container{
      width: 90% !important;
    }
    .gene_img{
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .gene_img img{
      width: 100%;
    }
  }
  .cons{
    display: none;
  }
</style>
<template>
  <div class="wrap wrap-intel">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/设备及原料/仪器设备/banner3.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>小型实验设备</h1>-->
<!--          <h2 class="mt10">满足不同需求的DNA/RNA合成</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;" v-if="!$route.meta.invisibles">
      <bread></bread>
    </div>
    <section class="container" v-if="!$route.meta.invisibles">
      <div class="con">
        <ul class="device">
          <li>
            <img src="@/assets/images/device_mini_1.png">
            <div class="info">
              <h4>MIX-2500 迷你混合仪</h4>
              <p>MIX-2500 迷你混合仪应用于生命科学和理化分析领域，用于样品组织....</p>
              <router-link to="/intel/MIX2500" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_2.png">
            <div class="info">
              <h4>RT-20 3D 混合仪</h4>
              <p>RT-20 3D 混合仪是由一个做圆周运动的摇床和一个摆臂组成的三维小摇床。</p>
              <router-link to="/intel/RT20" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_3.png">
            <div class="info">
              <h4>Mini系列 金属浴</h4>
              <p>Mini 系列金属浴是采用微电脑控制、可适用于车载电源的掌上型恒温....</p>
              <router-link to="/intel/metal" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_4.png">
            <div class="info">
              <h4>Mini-7KS 复合转子离心机 </h4>
              <p>Mini-7KS 复合转子离心机是我公司最新推出的掌 上型微型离心机，为国内....</p>
              <router-link to="/intel/mini_7ks" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_5.png">
            <div class="info">
              <h4>迷你离心机</h4>
              <p>迷你离心机外观新颖独特，灵巧多用，配备两种离心转子和多种试管套....</p>
              <router-link to="/intel/mini_centrifuge" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_6.png">
            <div class="info">
              <h4>T15KL 手持式无线均质仪</h4>
              <p>T15KL 手持式无线均质仪是一种依靠电机驱动研磨头的配有可充电电池的....</p>
              <router-link to="/intel/T15KL" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_7.png">
            <div class="info">
              <h4>MP-2500 微孔板离心机</h4>
              <p>MP-2500 微孔板离心机是一款是专门为微孔板设计的瞬时离心机....</p>
              <router-link to="/intel/mp2500" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_8.png">
            <div class="info">
              <h4>MC-15K 微型高速离心机</h4>
              <p>MC-15K 微型高速离心机是一款体积小噪音低，结构紧凑安全的微型高速离心机....</p>
              <router-link to="/intel/mc15k" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_9.png">
            <div class="info">
              <h4>TM-30 转盘混合仪</h4>
              <p>TM-30 转盘混合仪的工作原理是样品转盘绕 着转轴旋转....</p>
              <router-link to="/intel/tm30" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_mini_10.png">
            <div class="info">
              <h4>WH-5 / WH-10  水浴锅</h4>
              <p>恒温水浴槽是采用微电脑控制技术的多能恒温水槽，被广泛应用于医药、生化....</p>
              <router-link to="/intel/wh5" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
        </ul>
      </div>
      <div class="cons">
        <ul class="device">
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_1.png"></div>
            <div class="info">
              <h4>MIX-2500 迷你混合仪</h4>
              <p>MIX-2500 迷你混合仪应用于生命科学和理化分析领域，用于样品组织....</p>
              <router-link to="/intel/MIX2500" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_2.png"></div>
            <div class="info">
              <h4>RT-20 3D 混合仪</h4>
              <p>RT-20 3D 混合仪是由一个做圆周运动的摇床和一个摆臂组成的三维小摇床。</p>
              <router-link to="/intel/RT20" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_3.png"></div>
            <div class="info">
              <h4>Mini系列 金属浴</h4>
              <p>Mini 系列金属浴是采用微电脑控制、可适用于车载电源的掌上型恒温....</p>
              <router-link to="/intel/metal" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_4.png"></div>
            <div class="info">
              <h4>Mini-7KS 复合转子离心机 </h4>
              <p>Mini-7KS 复合转子离心机是我公司最新推出的掌 上型微型离心机，为国内....</p>
              <router-link to="/intel/mini_7ks" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_5.png"></div>
            <div class="info">
              <h4>迷你离心机</h4>
              <p>迷你离心机外观新颖独特，灵巧多用，配备两种离心转子和多种试管套....</p>
              <router-link to="/intel/mini_centrifuge" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_6.png"></div>
            <div class="info">
              <h4>T15KL 手持式无线均质仪</h4>
              <p>T15KL 手持式无线均质仪是一种依靠电机驱动研磨头的配有可充电电池的....</p>
              <router-link to="/intel/T15KL" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_7.png"></div>
            <div class="info">
              <h4>MP-2500 微孔板离心机</h4>
              <p>MP-2500 微孔板离心机是一款是专门为微孔板设计的瞬时离心机....</p>
              <router-link to="/intel/mp2500" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_8.png"></div>
            <div class="info">
              <h4>MC-15K 微型高速离心机</h4>
              <p>MC-15K 微型高速离心机是一款体积小噪音低，结构紧凑安全的微型高速离心机....</p>
              <router-link to="/intel/mc15k" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_9.png"></div>
            <div class="info">
              <h4>TM-30 转盘混合仪</h4>
              <p>TM-30 转盘混合仪的工作原理是样品转盘绕 着转轴旋转....</p>
              <router-link to="/intel/tm30" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_mini_10.png"></div>
            <div class="info">
              <h4>WH-5 / WH-10  水浴锅</h4>
              <p>恒温水浴槽是采用微电脑控制技术的多能恒温水槽，被广泛应用于医药、生化....</p>
              <router-link to="/intel/wh5" class="btn btn-primary">了解更多</router-link>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/device_3.vue